/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-01 13:52:03
 * @modify date 2022-12-10 22:36:25
 */

import { useState, lazy } from 'react';

// Router
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Material-ui & Theming
import { useTheme } from './config/Theme';
import { ThemeProvider } from '@mui/material/styles';

// Pages
import Layout from './components/pages/Layout';
import Home from './components/pages/home/Home';
const Books = lazy(() => import('./components/pages/books/Books'));
const Podcast = lazy(() => import('./components/pages/podcast/Podcast'));
const Blog = lazy(() => import('./components/pages/blog/Blog'));
const BlogSearch = lazy(() => import('./components/pages/blogsearch/BlogSearch'));
const Contact = lazy(() => import('./components/pages/contact/Contact'));
const Article = lazy(() => import('./components/pages/article/Article'));
const Book = lazy(() => import('./components/pages/book/Book'));
const Privacy = lazy(() => import('./components/pages/privacy/Privacy'));
const NotFound = lazy(() => import('./components/pages/notfound/NotFound'));

function App() {
  const [tab, setTab] = useState(0);

  return (
    <Router>
      <ThemeProvider theme={useTheme()}>
        <div data-testid="app" className="App">
          <Routes>
            <Route path="/" element={<Layout tab={tab} setTab={setTab} />} >
              <Route path="/" element={<Home />} />
              <Route path="/books" element={<Books tab={1} setTab={setTab} />} />
              <Route path="/books/:shortcode" element={<Book tab={1} setTab={setTab} />} />
              <Route path="/podcast" element={<Podcast tab={2} setTab={setTab} />} />
              <Route path="/blog" element={<Blog tab={3} setTab={setTab} />} />
              <Route path="/blog/search" element={<BlogSearch tab={3} setTab={setTab} />} />
              <Route path="/blog/:pageToken" element={<Blog tab={3} setTab={setTab} />} />
              <Route path="/blog/article/:postId" element={<Article tab={3} setTab={setTab} />} />
              <Route path="/etsy" element={<Navigate to="https://www.etsy.com/uk/shop/The2littlebugs?ref=paigehart-site-navigation" />} />
              <Route path="/contact" element={<Contact tab={5} setTab={setTab} />} />
              <Route path="/privacy" element={<Privacy tab={-1} setTab={setTab} />} />
              <Route path="*" element={<NotFound tab={-1} setTab={setTab} />} />
            </Route>
          </Routes>
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
